import script from "./DocumentosEstabelecimentoPastaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentosEstabelecimentoPastaPage.vue?vue&type=script&setup=true&lang=js"

import "./DocumentosEstabelecimentoPastaPage.vue?vue&type=style&index=0&id=fa177500&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa177500"]])

export default __exports__